import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Alert, Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { fetchSubscription } from "../api/subscriptionApi";
import { isProfileComplete } from "../utils/profile";

/** Require both onboarding steps before rendering paid application features. */
export default function OnboardingRoute({ children }) {
    const { user, profile, loading } = useAuth();
    const [billing, setBilling] = useState(null);
    const [billingLoading, setBillingLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (loading || !user || !isProfileComplete(profile)) {
            setBillingLoading(false);
            return;
        }

        let active = true;
        setBillingLoading(true);
        fetchSubscription()
            .then((result) => { if (active) setBilling(result); })
            .catch(() => { if (active) setError(true); })
            .finally(() => { if (active) setBillingLoading(false); });
        return () => { active = false; };
    }, [loading, user, profile]);

    if (loading || billingLoading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!isProfileComplete(profile)) {
        return <Navigate to="/profile?new=true" replace />;
    }

    if (error) {
        return (
            <Box sx={{ maxWidth: 560, mx: "auto", mt: 8, px: 2 }}>
                <Alert severity="error">We couldn't verify your subscription. Please refresh and try again.</Alert>
            </Box>
        );
    }

    if (billing?.subscriptionRequired && !billing.subscription?.active) {
        return <Navigate to="/subscribe" replace />;
    }

    return children;
}
